import React from 'react'
import { useParams, useRouteMatch } from 'react-router-dom'
import { BreadcrumbView } from '../../../../context/breadcrumb.context'
import { BadgeDanger, BadgeDark, BadgeSuccess } from '../../../../shared/component/badge'
import { Menu, MenuAdd, MenuDelete, MenuEdit, MenuItem } from '../../../../shared/menu/menu'
import { MenuRecycle } from '../../../../shared/menu/menu'
import { CardFullHeightScrollY } from '../../../../shared/card/card-full-height-scroll-y'
import { useApiFormManageAssessment, useApiListManageAssessment } from '../../../../api-new/state/assessment'
import { IconClose, IconActivate, IconDepublish, IconUnactivate, IconView, IconEdit, IconCopy, IconList } from '../../../../shared/icon/icon'
import { useRoleOrgAssessmentManage } from '../../../../role/hook/role-org'
import { TableAgClient } from '../../../../shared/table-builder/table-ag-client'
import { ColumnDate, ColumnMenu, ColumnSelector, ColumnText } from '../../../../shared/table-builder/table-columns'

export function AssessmentManageList() {
  const { url } = useRouteMatch()
  const { nodeID } = useParams()

  const apiListManageAssessment = useApiListManageAssessment()
  const apiFormManageAssessmentClone = useApiFormManageAssessment('/clone')

  const roleOrgAssessmentManage = useRoleOrgAssessmentManage()

  const handleReady = () => apiListManageAssessment.get(`${nodeID}/node`)

  const handleDestroyed = () => apiListManageAssessment.init()

  const handleClone = async assessment => {
    let cloneAssessment = {
      assessmentID: assessment.id,
      title: `${assessment.title} - copy`
    }

    await apiFormManageAssessmentClone.post(cloneAssessment)
    await apiListManageAssessment.get(`${nodeID}/node`)
  }

  const handleActive = async assessment => {
    await apiListManageAssessment.put(`${assessment.id}/activate`, assessment)
    await apiListManageAssessment.get(`${nodeID}/node`)
  }

  const handleDeactive = async assessment => {
    await apiListManageAssessment.put(`${assessment.id}/deactivate`, assessment)
    await apiListManageAssessment.get(`${nodeID}/node`)
  }

  const columnStatus = item =>
    <React.Fragment>
      {item.publishedOn && item.active && <BadgeSuccess value="active" />}
      {item.publishedOn && !item.active && <BadgeDanger value="inactive" />}
      {!item.publishedOn && !item.active && <BadgeDark value="unpublished" />}
    </React.Fragment>

  const HeaderMenu = () =>
    <Menu>
      <MenuAdd to={`${url}/add`} show={roleOrgAssessmentManage.accessCreate} />
      <MenuRecycle to={`${url}/recycle`} show={roleOrgAssessmentManage.accessDelete} />
    </Menu>

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text="Assessments">
        <CardFullHeightScrollY title="assessments" HeaderMenu={HeaderMenu}>
          <TableAgClient apiList={apiListManageAssessment} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnText field="title" />
            <ColumnText field="type" />
            <ColumnDate field="publishedOn" />
            <ColumnSelector field="status" selector={row => columnStatus(row)} />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuEdit to={`${url}/edit/${row.id}`} disabled={!!row.publishedOn} show={roleOrgAssessmentManage.accessUpdate} />
                  <MenuItem Icon={IconEdit} text="assignment" to={`${url}/edit/${row.id}/assignment`} show={roleOrgAssessmentManage.accessUpdate} />
                  <MenuItem
                    text="activate"
                    Icon={IconActivate}
                    onClick={() => handleActive(row)}
                    disabled={!row.publishedOn || row.active}
                    show={roleOrgAssessmentManage.accessUpdate}
                  />
                  <MenuItem
                    text="deactivate"
                    Icon={IconClose}
                    onClick={() => handleDeactive(row)}
                    disabled={!row.publishedOn || !row.active}
                    show={roleOrgAssessmentManage.accessUpdate}
                  />
                  <MenuItem
                    text="clear results"
                    Icon={IconUnactivate}
                    to={`${url}/edit/${row.id}/clear`}
                    disabled={!row.hasResults}
                    show={roleOrgAssessmentManage.accessUpdate}
                  />
                  <MenuItem
                    text="depublish"
                    Icon={IconDepublish}
                    to={`${url}/edit/${row.id}/depublish`}
                    disabled={!row.publishedOn || row.hasResults}
                    show={roleOrgAssessmentManage.accessUpdate}
                  />
                  <MenuItem text="view" Icon={IconView} to={`${url}/view/${row.id}`} show={roleOrgAssessmentManage.accessRead} />
                  <MenuItem text="copy" Icon={IconCopy} onClick={() => handleClone(row)} show={roleOrgAssessmentManage.accessUpdate} />
                  <MenuDelete to={`${url}/edit/${row.id}/delete/${row.id}`} show={roleOrgAssessmentManage.accessDelete} />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
